/* eslint-disable */

const pageContact = document.querySelector('body.template-contact');

if(pageContact) {

 // JavaScript to be fired on all pages
  mapboxgl.accessToken = 'pk.eyJ1Ijoid2ViLWlkZWEiLCJhIjoiY2tsMTB3azJvMHFzdDJubGJtamhnZmJqZSJ9.qHeHPxPqolYdxlTe_git_w';
  var map = new mapboxgl.Map({
  container: 'map',
  style: 'mapbox://styles/mapbox/streets-v11', // stylesheet location
  center: [6.381970769611551, 49.020552439864275], // starting position [lng, lat]
  zoom: 9 // starting zoom
  });

  const el = document.createElement('div');
  el.className = 'contact-marker';

  const popup = new mapboxgl.Popup({ offset: 25 });
  popup.setHTML(`<div class="popup_name">
                  Groupe Lorca
                  </div>
                  <p class="popup_address">
                  Route de Metz <br>
                  57580, LEMUD
                  </p>
                  <a href="tel:+33 (0)3 87 56 44 00">  
                  +33 (0)3 87 56 44 00
                  </a>`)

  new mapboxgl.Marker({element: el, anchor: 'bottom'})
              .setLngLat([6.381970769611551, 49.020552439864275])
              .setPopup(popup)
              .addTo(map);
}


// WEBPACK FOOTER //
// ./scripts/contact.js